import React, { useEffect } from "react";
import "./Secondary.css";

const Secondary = ({ text, action }) => {
  return (
    <button type="button" className="secondary body-1" onClick={() => action()}>
      {text}
    </button>
  );
};

export default Secondary;
